import { useMemo, useRef } from 'react'

import { ShipperMultiSelect } from '../inputs/ShipperMultiSelect'
import type {
  FilterSelectOption,
  MultiValueFilterComponentProps,
} from './types'

export const MultiSelectFilter = ({
  name,
  value,
  options,
  setQueryString,
  isLoading,
}: MultiValueFilterComponentProps & { isLoading?: boolean }) => {
  const selectOptions = options ?? []

  const selectedOptions = useMemo(
    () =>
      value
        .filter(v => v !== '')
        .map(v => selectOptions.find(opt => opt.value === v))
        .filter((o): o is FilterSelectOption => !!o),
    [selectOptions, value],
  )

  const shouldAutoFocus = useRef(selectedOptions.length === 0)

  return (
    <div className="mt-2 min-w-0">
      <ShipperMultiSelect
        name={name}
        options={selectOptions}
        value={selectedOptions}
        onChange={next => {
          setQueryString(qs => {
            const params = new URLSearchParams(qs)
            params.delete(name)
            next.forEach(opt => params.append(name, String(opt.value)))
            return params.toString()
          })
        }}
        getOptionLabel={o => o.text}
        getOptionValue={o => o.value}
        isLoading={isLoading}
        placeholder="Select or type to search..."
        autoFocus={shouldAutoFocus.current}
      />
    </div>
  )
}
